import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Formato } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesFormato, validationSchemaFormato } from "./FormatoCommon"
import FormatoForm from "./FormatoForm"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useFormatoCreate } from "../../hooks/formati"
import { transformErrorForForm } from "../../utils/utils"

export default function FormatoCreate() {
  const createFormato = useFormatoCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Formati", href: "/edizioni/formati" }, { label: "Creazione Formato" }])

  const initialValues = useMemo(() => initialValuesFormato(), [])
  const validationSchema = useMemo(() => validationSchemaFormato(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo formato</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createFormato.mutateAsync(values as Formato).then((formato) => {
                navigate(`/edizioni/formati`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <FormatoForm />
                </Container>
                <BottomFormFixed url="/edizioni/formati" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
